<template>
  <div class="c-app preika-app">
    <template v-if="sidebarType === 'admin'">
      <TheAdminSidebar/>
    </template>
    <template v-else-if="sidebarType === 'clerk'">
      <TheClerkSidebar/>
    </template>
    <template v-else>
      <TheSidebar/>
    </template>

    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="preika-page" mode="out-in">
              <router-view
                :key="routeViewKey"
                :class="routeViewClasses"
                :data-route-kind="routeViewKind"
              />
            </transition>
          </CContainer>
        </main>
        <TheFooter/>
      </div>
    </CWrapper>
    <GlobalCommandPalette :authority="sidebarType"/>
    <button
      type="button"
      class="preika-help-launcher"
      title="ヘルプ・操作ガイド"
      aria-label="ヘルプ・操作ガイドを開く"
      aria-haspopup="dialog"
      :aria-expanded="String(helpVisible)"
      @click="helpVisible = true"
    >
      <CIcon name="cil-lightbulb"/>
      <span>ヘルプ</span>
    </button>
    <HelpCenter
      :visible="helpVisible"
      :authority="sidebarType"
      @close="helpVisible = false"
    />
  </div>
</template>

<script>
import axios from 'axios'
import TheSidebar from './TheSidebar'
import TheAdminSidebar from './TheAdminSidebar'
import TheClerkSidebar from './TheClerkSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import GlobalCommandPalette from '../common/GlobalCommandPalette'
import HelpCenter from '../common/HelpCenter'
import {
  resolveRoutePresentation,
  routePresentationClasses
} from '../utils/routePresentation'

export default {
  name: 'TheContainer',

  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    TheAdminSidebar,
    TheClerkSidebar,
    GlobalCommandPalette,
    HelpCenter
  },

  data () {
    return {
      sidebarType: '',
      helpVisible: false
    }
  },

  computed: {
    routeViewKey () {
      return this.$route.fullPath
    },

    routeViewKind () {
      return resolveRoutePresentation(this.$route)
    },

    routeViewClasses () {
      return routePresentationClasses(this.$route)
    }
  },

  created () {
    axios
      .get(process.env.VUE_APP_API_ORIGIN + '/authority')
      .then(response => {
        this.sidebarType = response.data || ''
      })
      .catch(error => {
        console.error('権限情報の取得に失敗しました:', error)
        this.sidebarType = ''
      })
  }
}
</script>

<style scoped>
.preika-page-enter-active,
.preika-page-leave-active {
  transition: opacity .18s ease, transform .18s ease;
}

.preika-page-enter,
.preika-page-leave-to {
  opacity: 0;
  transform: translateY(5px);
}

.preika-help-launcher {
  position: fixed;
  z-index: 1040;
  right: 24px;
  bottom: 24px;
  display: inline-flex;
  min-height: 48px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 16px;
  border: 1px solid rgba(255, 255, 255, .72);
  border-radius: 16px;
  background: linear-gradient(145deg, #0a66b2, #084b83);
  box-shadow: 0 16px 34px rgba(5, 53, 89, .26);
  color: #fff;
  cursor: pointer;
  font-size: 11px;
  font-weight: 800;
  transition: box-shadow .16s ease, transform .16s ease;
}

.preika-help-launcher:hover,
.preika-help-launcher:focus {
  outline: none;
  box-shadow: 0 20px 40px rgba(5, 53, 89, .34), 0 0 0 4px rgba(44, 145, 220, .18);
  color: #fff;
  transform: translateY(-2px);
}

.preika-help-launcher .c-icon {
  width: 18px;
  height: 18px;
}

@media (max-width: 767.98px) {
  .preika-help-launcher {
    right: 14px;
    bottom: 14px;
    width: 48px;
    height: 48px;
    padding: 0;
    border-radius: 15px;
  }

  .preika-help-launcher span {
    display: none;
  }
}
</style>
